<div><mbs-alert-container></mbs-alert-container></div>
<div class="d-flex flex-column flex-fill w-100">
  <iframe
    [src]="iframeSrc() | safe: 'resourceUrl'"
    name="mbs-iframe-body"
    class="iframe-settings"
    [ngStyle]="{ visibility: loading() ? 'hidden' : 'visible' }"
    (load)="handleLoadIframe($event)"
    #iframeRef></iframe>
</div>
@if (loading()) {
  <mbs-loader />
}
<router-outlet></router-outlet>
